import type { SystemStyleObject } from '@hivewatch/dark'

export const notificationToastShellStyles = {
  alignItems: 'center',
  border: '1px solid',
  borderRadius: 'none',
  flexDirection: 'row',
  overflow: 'hidden',
  pe: '10px',
} satisfies SystemStyleObject
